import { FinanceApplicationCodes } from './FinanceApplicationCodes';

export class FinanceApplicationStatusModel {
    public code: FinanceApplicationCodes;
    public description: string;
    public eventDate: number;
    public id: string;
    public properties: FinanceApplicationProperties;
}

interface FinanceApplicationProperties {
    entry?: { key: string; value: string }[];
}